/**
 * Silently auto-applies PURE10 (10% off) to every customer's cart.
 *
 * Rule: only applies when the cart currently has NO discount code on it.
 * This is what keeps it from ever overriding CALM15 (the popup-subscriber
 * code) — a customer who has just claimed CALM15 already has a discount
 * on their cart, so this script leaves it alone. CALM15's own logic
 * (exit-intent-popup.js) always replaces whatever code is present when it
 * auto-applies, so CALM15 still wins even if PURE10 landed first.
 *
 * PURE10 is one-time-use per customer in Shopify. For a returning
 * customer who's already redeemed it, this call will simply fail to
 * apply anything (no error shown) — that's expected, not a bug.
 *
 * Runs on every storefront page load (skipped on /checkout) and again
 * after any successful add-to-cart, so it self-heals if the discount was
 * ever removed (e.g. a customer manually clears it, then keeps shopping).
 */
(function () {
  'use strict';

  if (/^\/checkout(\/|$)/.test(window.location.pathname)) {
    return;
  }

  var CODE = 'PURE10';

  function applyIfNoDiscount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasDiscount =
          (cart.total_discount && cart.total_discount > 0) ||
          (cart.items || []).some(function (item) {
            return item.discounts && item.discounts.length > 0;
          });

        if (hasDiscount) return;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: CODE })
        });
      })
      .catch(function () {
        /* best-effort, silent */
      });
  }

  applyIfNoDiscount();

  function isCartAddUrl(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isAdd = isCartAddUrl(url) && String(method).toUpperCase() === 'POST';
      var result = originalFetch.apply(this, arguments);
      if (isAdd) {
        result.then(function (response) {
          if (response && response.ok) applyIfNoDiscount();
        }).catch(function () {});
      }
      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartAddUrl(url) && String(method).toUpperCase() === 'POST') {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) applyIfNoDiscount();
      });
    }
    return originalOpen.apply(this, arguments);
  };
})();
